/*
  Move the item at startIndex to endIndex
*/
export default function reorder<T>(items: T[], startIndex: number, endIndex: number): T[] {
  const result = Array.from(items);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
}
